import SafePayScreen from 'features/believe/SafePayScreen/SafePayScreen';
import React from 'react';

export default function SafePayPage() {
  return <SafePayScreen />;
}
